import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const isDashboard = window.location.pathname.startsWith('/dashboard');

    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const reg of registrations) {
        const scope = reg.scope;
        const isDashboardScope = scope.includes('/dashboard');
        if (!isDashboard || !isDashboardScope) {
          reg.unregister();
        }
      }
    });

    if (isDashboard) {
      navigator.serviceWorker.register('/sw.js', { scope: '/dashboard' }).catch(() => {});
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
